import { Injectable } from '@angular/core';
import { SecurityService } from '../security/services/security.service';
import { ServicesHelperService } from '../services/services-helper.service';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { map, catchError, filter, take, switchMap } from 'rxjs/operators';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private securityService: SecurityService, private servicesHelperService: ServicesHelperService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headers = request.headers['lazyUpdate'];
    if (headers == null || headers.length <= 0) {
      request = request.clone({ responseType: 'json', headers: this.servicesHelperService.getHeaders() });
    }

    const response = next.handle(request).pipe(
      map(
        (event: HttpEvent<any>): HttpEvent<any> => {
          if (event instanceof HttpResponse) {
          }
          return event;
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      })
    );

    return response;
  }
}
